export const mockButtonLink = {
  id: '',
  url: '',
  linktype: 'url',
  fieldtype: 'multilink',
  cached_url: '',
};

export const mockAddress = {
  type: 'doc',
  content: [
    {
      type: 'paragraph',
      content: [
        {
          text: 'Geiger Gruppe',
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
        },
        {
          type: 'hard_break',
        },
        {
          text: 'Wilhelm-Geiger-Straße 1',
          type: 'text',
        },
        {
          type: 'hard_break',
        },
        {
          text: '87561 Oberstdorf',
          type: 'text',
        },
      ],
    },
  ],
};

export const mockFooterLeftNav = [
  {
    _uid: '2fb72894-b380-4370-b3c9-7669a7627650',
    link: {
      id: '42a03840-cdf6-496b-80ed-b01e6fbd7be9',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/geiger-gruppe/familie-vision-werte/',
      story: {
        name: 'Familie, Vision & Werte ',
        id: 210840858,
        uuid: '42a03840-cdf6-496b-80ed-b01e6fbd7be9',
        slug: 'familie-vision-werte',
        url: 'familie-vision-werte/',
        full_slug: 'de-de/geiger-gruppe/familie-vision-werte',
        _stopResolving: true,
      },
    },
    label: 'Familie, Vision & Werte',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "2fb72894-b380-4370-b3c9-7669a7627650", "id": "182510863"}-->',
  },
  {
    _uid: '9737ccad-f041-45e0-96bd-6625d42a1531',
    link: {
      id: 'f55d9064-2fe1-40a3-8cbb-ab440b94a50e',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/geiger-gruppe/kreislaufgesellschaft/',
      story: {
        name: 'Kreislaufgesellschaft',
        id: 308665498,
        uuid: 'f55d9064-2fe1-40a3-8cbb-ab440b94a50e',
        slug: 'kreislaufgesellschaft',
        url: 'kreislaufgesellschaft/',
        full_slug: 'de-de/geiger-gruppe/kreislaufgesellschaft',
        _stopResolving: true,
      },
    },
    label: 'Kreislaufgesellschaft',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "9737ccad-f041-45e0-96bd-6625d42a1531", "id": "182510863"}-->',
  },
  {
    _uid: '92ba634c-499d-4276-8dbc-6c88e98ab5a9',
    link: {
      id: '6e707e5f-6c63-4ebd-a520-8dd7991f074c',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/zertifikate/',
      story: {
        name: 'Zertifikate',
        id: 246081092,
        uuid: '6e707e5f-6c63-4ebd-a520-8dd7991f074c',
        slug: 'zertifikate',
        url: 'zertifikate/',
        full_slug: 'de-de/zertifikate',
        _stopResolving: true,
      },
    },
    label: 'Zertifikate',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "92ba634c-499d-4276-8dbc-6c88e98ab5a9", "id": "182510863"}-->',
  },
  {
    _uid: '0a71a59e-e48d-4473-9c38-31e26901e963',
    link: {
      id: 'cf8563f0-1345-468e-8d4d-df7b0b3a9a23',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/downloadcenter',
      story: {
        name: 'Downloadcenter',
        id: 219459190,
        uuid: 'cf8563f0-1345-468e-8d4d-df7b0b3a9a23',
        slug: 'downloadcenter',
        url: 'de-de/downloadcenter',
        full_slug: 'de-de/downloadcenter',
        _stopResolving: true,
      },
    },
    label: 'Downloadcenter ',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "0a71a59e-e48d-4473-9c38-31e26901e963", "id": "182510863"}-->',
  },
  {
    _uid: 'd87ce8f8-5482-4271-b876-de290f2084de',
    link: {
      id: 'b5be4d55-9130-4d77-b85e-5a10bf3d9dcb',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/presse',
      story: {
        name: 'Presse',
        id: 219456823,
        uuid: 'b5be4d55-9130-4d77-b85e-5a10bf3d9dcb',
        slug: 'presse',
        url: 'de-de/presse',
        full_slug: 'de-de/presse',
        _stopResolving: true,
      },
    },
    label: 'Presse',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "d87ce8f8-5482-4271-b876-de290f2084de", "id": "182510863"}-->',
  },
];

export const mockFooterRightNav = [
  {
    _uid: '78027d77-27d1-4e7e-87bf-dda9cb532aef',
    link: {
      id: '2b39e503-08fc-4b4e-826e-1cfd52b3a12c',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/karriere/geiger-als-arbeitgeber/',
      story: {
        name: 'Geiger als Arbeitgeber',
        id: 212028707,
        uuid: '2b39e503-08fc-4b4e-826e-1cfd52b3a12c',
        slug: 'geiger-als-arbeitgeber',
        url: 'geiger-als-arbeitgeber/',
        full_slug: 'de-de/karriere/geiger-als-arbeitgeber',
        _stopResolving: true,
      },
    },
    label: 'Geiger als Arbeitgeber',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "78027d77-27d1-4e7e-87bf-dda9cb532aef", "id": "182510863"}-->',
  },
  {
    _uid: '9709f6af-d13e-43bf-99d2-016a9c8bf913',
    link: {
      id: 'd7f5a5e7-cb8a-427b-9bc2-81fdbbb61961',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/karriere/direkteinstieg/',
      story: {
        name: 'Direkteinsteigende',
        id: 205313607,
        uuid: 'd7f5a5e7-cb8a-427b-9bc2-81fdbbb61961',
        slug: 'direkteinsteigende',
        url: 'direkteinsteigende/',
        full_slug: 'de-de/karriere/direkteinsteigende',
        _stopResolving: true,
      },
    },
    label: 'Direkteinsteigende',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "9709f6af-d13e-43bf-99d2-016a9c8bf913", "id": "182510863"}-->',
  },
  {
    _uid: '307832ed-9d2f-4d42-89af-4696cc5635ac',
    link: {
      id: 'e5043178-5903-45dc-a087-da4d79d5c44a',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/karriere/ausbildung-und-duales-studium',
      story: {
        name: 'Schülerinnen & Schüler',
        id: 205313204,
        uuid: 'e5043178-5903-45dc-a087-da4d79d5c44a',
        slug: 'schuelerinnen-und-schueler',
        url: 'schuelerinnen-und-schueler/',
        full_slug: 'de-de/karriere/schuelerinnen-und-schueler',
        _stopResolving: true,
      },
    },
    label: 'Schülerinnen & Schüler',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "307832ed-9d2f-4d42-89af-4696cc5635ac", "id": "182510863"}-->',
  },
  {
    _uid: '68c309d5-a964-46bc-bdc8-f883a8eb0f56',
    link: {
      id: 'c9e857c2-cbff-4dfb-86d5-a41fc7e318ca',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/karriere/studierende/',
      story: {
        name: 'Studierende',
        id: 205313311,
        uuid: 'c9e857c2-cbff-4dfb-86d5-a41fc7e318ca',
        slug: 'studierende',
        url: 'studierende/',
        full_slug: 'de-de/karriere/studierende',
        _stopResolving: true,
      },
    },
    label: 'Studierende',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "68c309d5-a964-46bc-bdc8-f883a8eb0f56", "id": "182510863"}-->',
  },
  {
    _uid: '22f57389-a4b6-418f-a9c0-a010dd9cd108',
    link: {
      id: 'b3b0837f-5a6b-464f-8b95-2452c1632352',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/karriere/stellenangebote/',
      story: {
        name: 'Stellenangebote',
        id: 205318174,
        uuid: 'b3b0837f-5a6b-464f-8b95-2452c1632352',
        slug: 'stellenangebote',
        url: 'stellenangebote/',
        full_slug: 'de-de/karriere/stellenangebote',
        _stopResolving: true,
      },
    },
    label: 'Stellenangebote',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "22f57389-a4b6-418f-a9c0-a010dd9cd108", "id": "182510863"}-->',
  },
];

export const mockSocialLinks = [
  {
    _uid: '26918385-239b-46eb-a3cb-8bf1fe39d76c',
    link: {
      id: '',
      url: 'https://www.geigergruppe.de/facebook',
      linktype: 'url',
      fieldtype: 'multilink',
      cached_url: 'https://www.geigergruppe.de/facebook',
    },
    label: 'facebook',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "26918385-239b-46eb-a3cb-8bf1fe39d76c", "id": "182510863"}-->',
  },
  {
    _uid: 'cef11b9a-6e7d-4cfd-bafb-b89c2f8292be',
    link: {
      id: '',
      url: 'https://www.geigergruppe.de/instagram',
      linktype: 'url',
      fieldtype: 'multilink',
      cached_url: 'https://www.geigergruppe.de/instagram',
    },
    label: 'instagram',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "cef11b9a-6e7d-4cfd-bafb-b89c2f8292be", "id": "182510863"}-->',
  },
  {
    _uid: 'c8bf714a-fa84-4cdc-b110-819645200aea',
    link: {
      id: '',
      url: 'https://www.geigergruppe.de/youtube',
      linktype: 'url',
      fieldtype: 'multilink',
      cached_url: 'https://www.geigergruppe.de/youtube',
    },
    label: 'youtube',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "c8bf714a-fa84-4cdc-b110-819645200aea", "id": "182510863"}-->',
  },
  {
    _uid: 'e24bb17c-5a3e-431e-a14b-edbd8b7cd3fb',
    link: {
      id: '',
      url: 'https://www.geigergruppe.de/xing',
      linktype: 'url',
      fieldtype: 'multilink',
      cached_url: 'https://www.geigergruppe.de/xing',
    },
    label: 'xing',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "e24bb17c-5a3e-431e-a14b-edbd8b7cd3fb", "id": "182510863"}-->',
  },
  {
    _uid: 'a624c192-ba04-4f86-9cad-53a2e541274a',
    link: {
      id: '',
      url: 'https://www.geigergruppe.de/linkedin',
      linktype: 'url',
      fieldtype: 'multilink',
      cached_url: 'https://www.geigergruppe.de/linkedin',
    },
    label: 'linkedin',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "a624c192-ba04-4f86-9cad-53a2e541274a", "id": "182510863"}-->',
  },
  {
    _uid: 'd26ca49a-3914-4687-8945-bde57c2e4982',
    link: {
      id: '',
      url: 'https://www.geigergruppe.de/kununu',
      linktype: 'url',
      fieldtype: 'multilink',
      cached_url: 'https://www.geigergruppe.de/kununu',
    },
    label: 'kununu',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "d26ca49a-3914-4687-8945-bde57c2e4982", "id": "182510863"}-->',
  },
];

export const mockLegalLinks = [
  {
    _uid: 'cc9f68cd-0809-40c1-81fc-2661100211f3',
    link: {
      id: 'a8e3b083-3989-4561-9473-25be5cc7f582',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/mitarbeiter-login/',
      story: {
        name: 'Mitarbeiter Login',
        id: 237090302,
        uuid: 'a8e3b083-3989-4561-9473-25be5cc7f582',
        slug: 'mitarbeiter-login',
        url: 'mitarbeiter-login/',
        full_slug: 'de-de/mitarbeiter-login',
        _stopResolving: true,
      },
    },
    label: 'Mitarbeiter-Login',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "cc9f68cd-0809-40c1-81fc-2661100211f3", "id": "182510863"}-->',
  },
  {
    _uid: 'e0870f0d-5596-43ce-8d50-bed1f503ea30',
    link: {
      id: 'be216efa-23fe-45bb-b95f-3b07cc2b9984',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/impressum/',
      story: {
        name: 'Impressum',
        id: 236281083,
        uuid: 'be216efa-23fe-45bb-b95f-3b07cc2b9984',
        slug: 'impressum',
        url: 'impressum/',
        full_slug: 'de-de/impressum',
        _stopResolving: true,
      },
    },
    label: 'Impressum',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "e0870f0d-5596-43ce-8d50-bed1f503ea30", "id": "182510863"}-->',
  },
  {
    _uid: '18af53e1-e81d-48b6-abba-bf79b45950cd',
    link: {
      id: '7c72f7da-e812-4287-85bc-3188390eed3a',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/agb/',
      story: {
        name: 'AGB',
        id: 231271403,
        uuid: '7c72f7da-e812-4287-85bc-3188390eed3a',
        slug: 'agb',
        url: 'agb/',
        full_slug: 'de-de/agb',
        _stopResolving: true,
      },
    },
    label: 'AGB',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "18af53e1-e81d-48b6-abba-bf79b45950cd", "id": "182510863"}-->',
  },
  {
    _uid: 'eb890f4f-446e-4834-a3b6-22b05cf17f2a',
    link: {
      id: '4d7db1b1-c23e-49c0-be03-952fab571638',
      url: '',
      linktype: 'story',
      fieldtype: 'multilink',
      cached_url: 'de-de/datenschutz/',
      story: {
        name: 'Datenschutz',
        id: 236144255,
        uuid: '4d7db1b1-c23e-49c0-be03-952fab571638',
        slug: 'datenschutz',
        url: 'datenschutz/',
        full_slug: 'de-de/datenschutz',
        _stopResolving: true,
      },
    },
    label: 'Datenschutz',
    component: 'linkComponent',
    _editable:
      '<!--#storyblok#{"name": "linkComponent", "space": "167299", "uid": "eb890f4f-446e-4834-a3b6-22b05cf17f2a", "id": "182510863"}-->',
  },
];

export default { mockButtonLink, mockAddress, mockFooterLeftNav, mockFooterRightNav, mockSocialLinks, mockLegalLinks };
